import { render, staticRenderFns } from "./validasi.vue?vue&type=template&id=2af26b9b"
import script from "./validasi.vue?vue&type=script&lang=js"
export * from "./validasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports